export default "__VITE_ASSET__Cirrk$V$__"